import { STATUS_LABELS } from './types';

import type { TenantLifecycleHistoryEventWire } from '../../../lib/api-client';

interface TenantLifecycleHistoryTimelineProps {
  history: TenantLifecycleHistoryEventWire[];
}

/**
 * TenantLifecycleHistoryTimeline — exibe histórico de transições de lifecycle.
 *
 * Ordem: mais recente primeiro (server retorna assim).
 * D-B: gate do pai (tenant-lifecycle-read).
 */
export function TenantLifecycleHistoryTimeline({
  history,
}: TenantLifecycleHistoryTimelineProps): JSX.Element {
  if (history.length === 0) {
    return (
      <div style={{ padding: '16px 0', textAlign: 'center', color: '#9ca3af', fontSize: 13 }}>
        Nenhuma transição registrada.
      </div>
    );
  }

  return (
    <ol style={{ listStyle: 'none', margin: 0, padding: 0 }}>
      {history.map((event, idx) => (
        <li
          key={event.id}
          style={{
            display: 'flex',
            gap: 12,
            paddingBottom: idx < history.length - 1 ? 16 : 0,
            position: 'relative',
          }}
        >
          {/* Line connector */}
          {idx < history.length - 1 && (
            <div
              style={{
                position: 'absolute',
                left: 9,
                top: 20,
                width: 2,
                bottom: 0,
                backgroundColor: '#e5e7eb',
              }}
            />
          )}

          {/* Dot */}
          <div
            style={{
              width: 20,
              height: 20,
              borderRadius: '50%',
              backgroundColor: '#6366f1',
              border: '2px solid #fff',
              boxShadow: '0 0 0 2px #e0e7ff',
              flexShrink: 0,
              marginTop: 1,
            }}
          />

          <div style={{ flex: 1, minWidth: 0 }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                flexWrap: 'wrap',
                marginBottom: 2,
              }}
            >
              <span style={{ fontSize: 12, fontWeight: 600, color: '#374151' }}>
                {STATUS_LABELS[event.fromStatus as keyof typeof STATUS_LABELS] ?? event.fromStatus}
              </span>
              <span style={{ color: '#9ca3af', fontSize: 12 }}>→</span>
              <span style={{ fontSize: 12, fontWeight: 700, color: '#4f46e5' }}>
                {STATUS_LABELS[event.toStatus as keyof typeof STATUS_LABELS] ?? event.toStatus}
              </span>
            </div>

            {event.reason && (
              <div
                style={{
                  fontSize: 11,
                  color: '#6b7280',
                  marginBottom: 3,
                  fontStyle: 'italic',
                }}
              >
                &quot;{event.reason}&quot;
              </div>
            )}

            <div style={{ fontSize: 11, color: '#9ca3af' }}>
              {event.actorSystem
                ? `Sistema: ${event.actorSystem}`
                : event.actorUserId
                  ? `Usuário: ${event.actorUserId}`
                  : 'Automático'}
              {' · '}
              {new Date(event.transitionedAt).toLocaleString('pt-BR', {
                dateStyle: 'short',
                timeStyle: 'short',
              })}
            </div>
          </div>
        </li>
      ))}
    </ol>
  );
}
